import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnHeaderBtnComponent } from './dn-header-btn.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [DnHeaderBtnComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [DnHeaderBtnComponent],
})
export class DnHeaderBtnModule {}
